import {navigateToContents} from '../utils/operations'
import React, {Component} from 'react';
import { connect } from 'react-redux'
import FileUtils from '../utils/FileUtils'
import Lightbox from 'react-images';
import update from 'immutability-helper';
import ISpan from "../i18n/ISpan";


class SearchResult extends Component{
    constructor(props){
        super(props);
        this.state = {
            showMoreInformation: false,
            showFullscreen: false
        };
    }

    getItemCaption(item){
        return item.title;
    }

    render(){
        let item = this.props.item;
        item.isContainer = () => item.contentType !== "tam2:image";

        return  <div className={"search-result row"} key={item.archiveref}>
            <div className={"two columns"}>
                {
                    item.isContainer() ?
                        <a href="#" onClick={this.props.navigateToContents}> <span className={"fa fa-folder-o fa-5x thumbnail-icon"}></span>
                        </a>
                        :
                        <span>
                            <a href="#"  onClick={()=> { this.setState(update(this.state, {showFullscreen: {$set: !this.state.showFullscreen}})); }}>
                                <img alt="" src={FileUtils.getAbsoluteUrl(item.thumbnailUrl)}/>
                            </a>
                            <Lightbox currentImage={0}
                                      images={[{src: FileUtils.getAbsoluteUrl(item.contentUrl), caption: this.getItemCaption(item)}]}
                                      isOpen={this.state.showFullscreen}
                                      onClickImage={(e)=>{return false;}}
                                      onClickPrev={()=>{}}
                                      onClickNext={()=>{}}
                                      onClose={()=>{
                                          this.setState(update(this.state, {
                                              showFullscreen: {$set: false}
                                          }));
                                      }}
                                      backdropClosesModal={true}/>
                        </span>

                }
            </div>

            <div className={"seven columns"}>
                <div>
                    {this.getTitleBlock(item)}
                </div>
                {
                    item.isContainer() && <div>
                        <span className={"fa fa-angle-double-right"}></span>
                        <a href="#" className={"view-contents-link"} onClick={this.props.navigateToContents}><ISpan localisationId="common.labels.search_results.view_contents" defaultValue="VIEW CONTENTS"/></a>
                    </div>
                }

                {
                    this.getDetailsBlock(item)
                }


                {
                    !item.isContainer() && <div className={"show-more"}>
                        <a href="#" onClick={(e)=>{
                            e.preventDefault()
                            let showMore = this.state.showMoreInformation;
                            this.setState({
                                showMoreInformation:!showMore
                            })
                        }}><ISpan localisationId="common.labels.search_results.show_more_information" defaultValue="More Information"/></a>
                    </div>
                }

                {
                    (this.state.showMoreInformation) &&
                    this.getMoreInformationBlock(item)
                }
            </div>
        </div>
    }

    getTitle(item) {
        return item.title;
    }

    getMoreInformationBlock(item) {
        return <div className={"more-information-container"} data-bind="visible: showMoreInformation">
            <div className={"description"} data-bind="text:note">{item.description}</div>
            <div className={"Copyright"} data-bind="text:copyright">{item.copyright}</div>
            <div className={"outline-container"} data-bind="text:outline, visible: outline() != ''"> {item.outline} </div>
            <div className={"contenttype-container"} data-bind="text:contentType">{item.contentType}</div>
        </div>
    }

    getDetailsBlock(item) {
        return <span className={"archiveref-container"}><a data-bind="attr: {href : externalArchiveUrl}, text: archiveref"> {item.archiveref} </a></span>
    }

    getTitleBlock(item) {
        return <div className={"title"}>
            <strong>{this.getTitle(item)}</strong>
        </div>;
    }
}

class SagaSearchResult extends SearchResult{
    getTitle(item){
        return item.artistFirstName + " " + item.artistLastName;
    }

    getItemCaption(item){
        let labels = [];
        labels.push(item.publication);
        labels.push(item.serie);
        labels.push(item.publicationNr? "nr. " + item.publicationNr : "");
        labels.push("(" + item.imageSize + ")");
        return labels.join(" · ");
    }

    getDetailsBlock(item) {
        return <span>
                <div className="saga-publication-title" data-bind="visible: publication(), text:publication">{item.publication}</div>
                <div className="saga-publication inline-label" data-bind="visible: serie(), text:serie">{item.serie}</div>


            {item.publicationNr && <div className="inline-label serie-number-label" data-bind="visible: publicationNr()">nr.</div>}
            {item.publicationNr && <div className="saga-publication-nr inline-label" data-bind="visible: publicationNr(), text:publicationNr">{item.publicationNr}</div>}


                <div className="publication-year" data-bind="visible: publicationYear(), text:publicationYear">{item.publicationYear}</div>
            </span>;
    }

    getMoreInformationBlock(item) {
        return <div className={"more-information-container"} data-bind="visible: showMoreInformation">
            <div className={"description"} data-bind="text:note">{item.fileName}</div>
            <div className={"description"} data-bind="text:note">{item.imageSize}</div>
            <div className={"description"} data-bind="text:note">{item.description}</div>
            <div className={"Copyright"} data-bind="text:copyright">{item.copyright}</div>
            <div className={"outline-container"} data-bind="text:outline, visible: outline() != ''"> {item.outline} </div>
            <div className={"contenttype-container"} data-bind="text:contentType">{item.contentType}</div>
        </div>
    }
}


SearchResult = connect(null, (dispatch, ownProps) => {
    return {
        navigateToContents: () => {
            dispatch(navigateToContents(ownProps.item.archiveref))
        }
    }
})(SearchResult);


export {SearchResult, SagaSearchResult}


// WEBPACK FOOTER //
// ./src/components/SearchResult.js